import { facadeApi } from 'api'
import { DevHubDownloadInfo } from 'types/attachments/attachments'

interface Params {
  keys: string[]
}

export const generateDevHubDownloadUrlsApi = ({ keys }: Params) =>
  facadeApi.post<{ data: DevHubDownloadInfo[] }>('/devhub/generate-download-urls', { keys })
